// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // API_URL: 'http://local.api.iviaggio.it/api/v1',
    API_URL: 'https://api.iviaggio.it/api/v1',
    STS_TOKEN: 'hVyizJyxX6LOp62B4EeNZkKdl3sxomFM.Vv7MX2KHuUDEpS7nnp3395HY28sE9HW8.XZHWBWsMyUXyaHms9glpNZ7ok9ismngd'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
